import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Nullable } from '@coworkrz/core/types';

@Injectable({
  providedIn: 'root',
})
export class HttpBaseService {
  protected http = inject(HttpClient);

  protected createHttpParams<P>(filters?: Nullable<P>): HttpParams {
    let params = new HttpParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            const truthyValues = value.filter((v) => v);
            if (truthyValues.length)
              params = params.set(key, truthyValues.join(','));
          } else {
            params = params.set(key, String(value));
          }
        }
      });
    }
    return params;
  }
}
